import { useQuery } from '@tanstack/react-query'
import {
	type HttpGetExperienceShellGalleryImagesOptions,
	httpGetExperienceShellGalleryImages
} from '@/features/experience-shell/http/experience-shell.http.ts'
import { QUERY_KEYS } from '@/query-client'

export const useGetExperienceShellGalleryImages = (
	urlParams: HttpGetExperienceShellGalleryImagesOptions['urlParams']
) => {
	return useQuery({
		queryKey: [
			QUERY_KEYS.EXPERIENCE_SHELL_GALLERY_IMAGES,
			urlParams.experienceId
		],
		queryFn: () =>
			httpGetExperienceShellGalleryImages({
				urlParams,
				params: { response_type: 'extended' }
			})
	})
}
